export enum RewardTypeEnum {
  Registration = 'registration',
  Purchased = 'purchased',
  Deduction = 'deduction',
  Revert = 'revert'
}
